<template>
  <el-form :model="packInfoConfig" ref="packInfoConfig" label-width="125px">
    <p class="title_label"><b>应用包体信息配置</b></p>
    <el-form-item label="应用图标" style="margin-top: 10px">
      <img v-if="packInfoConfig.iconPath" :src="packInfoConfig.iconPath" class="no-image" />
      <el-upload
        class="avatar-uploader"
        :action="uploadUrl"
        :show-file-list="false"
        :on-success="handleSuccess"
        :with-credentials="true"
        :before-upload="beforeUpload"
      >
        <i class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </el-form-item>
    <el-form-item
      label="应用名称"
      prop="appName"
      :rules="{
        required: true,
        message: '应用名称不能为空',
        trigger: 'blur'
      }"
    >
      <el-input v-model="packInfoConfig.appName" size="small" maxlength="40"></el-input>
      <span class="tips">系统中显示名称</span>
    </el-form-item>
    <el-form-item
      label="显示名称"
      prop="clientGameName"
      :rules="{
        required: true,
        message: '显示名称不能为空',
        trigger: 'blur'
      }"
    >
      <el-input v-model="packInfoConfig.clientGameName" size="small" maxlength="100"></el-input>
      <span class="tips">玩家下载应用显示在手机上的名称</span>
    </el-form-item>
    <el-form-item
      label="应用包名"
      prop="packageName"
      :rules="{
        required: true,
        message: '应用包名不能为空',
        trigger: 'blur'
      }"
    >
      <el-input v-model="packInfoConfig.packageName" size="small" maxlength="200"></el-input>
      <span class="tips">应用文件在系统中显示的名称</span>
    </el-form-item>
    <el-form-item label="资源替换" v-if="!packInfoConfig.splashPath && !replaceResourceList.length">
      <img src="~@/assets/images/no-image.png" alt="" class="no-image nobd" />
    </el-form-item>
    <div v-else>
      <p class="title_label"><b>资源替换</b></p>
      <el-form-item label="启动闪屏">
        <img :src="packInfoConfig.splashPath" alt="" class="resourceImg" v-if="packInfoConfig.splashPath" />
        <el-upload
          class="avatar-uploader upload-resource"
          :action="uploadUrl"
          :show-file-list="false"
          :on-success="handleSuccessSplashPath"
          :with-credentials="true"
          :before-upload="beforeUpload"
        >
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item v-for="(item, index) in packInfoConfig.replaceResourceList" :label="'路径名称' + (index + 1)" :key="index">
        <div @click="uploadResource(index)">
          <el-input class="resource" :disabled="true" v-model="item.resourceUrl" size="small"></el-input>
          <img :src="item.imgUrl" class="resourceImg" alt="" v-if="item.imgUrl" />
          <el-upload
            class="avatar-uploader upload-resource"
            :action="uploadUrl"
            :show-file-list="false"
            :on-success="handleSuccessUrl"
            :with-credentials="true"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <i class="el-icon-delete dele" @click="deleUrl(index)"></i>
        </div>
      </el-form-item>
    </div>
  </el-form>
</template>
<script>
import { HOST_API } from '@/api/config'
export default {
  name: 'packInfoConfig',
  props: ['fromPackData'],
  data() {
    return {
      packInfoConfig: {},
      uploadUrl: HOST_API + '/api/ptom/aggregation/uploadAppImage',
      index: 0
    }
  },
  watch: {
    fromPackData() {
      this.query()
    }
  },
  created() {
    this.query()
  },
  methods: {
    query() {
      this.packInfoConfig = JSON.parse(JSON.stringify(this.fromPackData))
      const packConfig = this.packInfoConfig
      // 应用名称截取
      if (packConfig.appName.includes('-')) {
        const splitAppName = packConfig.appName.split('-')
        splitAppName.pop()
        packConfig.appName = splitAppName.join('-')
      }
      // 获取应用icon
      packConfig.iconPath = packConfig.openGameIconRootPath + packConfig.iconPath
      // 获取闪屏图片
      packConfig.splashPath = packConfig.splashPathPrefix + packConfig.splashPath
      // 获取资源马甲包
      if (packConfig.replaceResourceList.length > 0) {
        packConfig.replaceResourceList.forEach((item) => {
          item.imgUrl = item.middleWareUrlRootPath + item.replaceResourceUrl
        })
      }
    },
    handleSuccess(res, file) {
      this.publicHandle(res)
      this.packInfoConfig.iconPath = res.data
    },
    publicHandle(res) {
      if (res.code !== 200) {
        this.$message.error(res.msg)
      }
    },
    handleSuccessUrl(res, file) {
      this.publicHandle(res)
      const resourceList = this.packInfoConfig.replaceResourceList
      resourceList.splice(this.index, 1, {
        ...resourceList[this.index],
        imgUrl: res.data
      })
    },
    handleSuccessSplashPath(res, file) {
      this.publicHandle(res)
      this.packInfoConfig.splashPath = res.data
    },
    uploadResource(index) {
      this.index = index
    },
    deleUrl(index) {
      const resourceList = this.packInfoConfig.replaceResourceList
      resourceList.splice(this.index, 1, {
        ...resourceList[this.index],
        imgUrl: ''
      })
    },
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png'
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isJPG) {
        this.$message.error('上传文件只能是 JPG/png 格式!')
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!')
      }
      return isJPG && isLt10M
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.avatar-uploader) {
  display: inline-block;
  line-height: 0;
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .el-upload:hover {
    border-color: #409eff;
  }
}
:deep(.avatar-uploader-icon) {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
:deep(.el-input) {
  width: 300px;
}
.resourceImg {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin: 5px 10px 0 0;
  vertical-align: top;
  border: 1px solid #f2f2f2;
  border-radius: 5px;
}
:deep(.upload-resource) {
  width: 30px;
  height: 30px;
  margin-top: 5px;
  .avatar-uploader-icon {
    width: 30px;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
  }
  .el-upload {
    height: 30px;
    line-height: 30px;
  }
}
.resource {
  float: left;
  margin-right: 10px;
}
.tips {
  display: block;
  line-height: 24px;
  font-size: 12px;
  color: #606266;
  &::before {
    content: '*';
    display: inline-block;
    margin-right: 5px;
    // color: #f00;
    font-size: 14px;
  }
}
.no-image {
  display: inline-block;
  width: 60px;
  height: 60px;
  margin-right: 8px;
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  vertical-align: top;
}
.nobd {
  border: none;
}
p.title_label {
  padding-left: 20px;
  line-height: 30px;
  font-size: 16px;
}
.dele {
  display: inline-block;
  margin: 13px 0 0 10px;
  font-size: 14px;
  vertical-align: top;
  cursor: pointer;
}
</style>
